// extracted by mini-css-extract-plugin
export default {"paginationWrap":"ThePagination_paginationWrap_sWoUM","disabled":"ThePagination_disabled_va5Pc","active":"ThePagination_active_C1Ces"};